import { render, staticRenderFns } from "./single-item.vue?vue&type=template&id=10682d14&"
import script from "./single-item.vue?vue&type=script&lang=ts&"
export * from "./single-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10682d14')) {
      api.createRecord('10682d14', component.options)
    } else {
      api.reload('10682d14', component.options)
    }
    module.hot.accept("./single-item.vue?vue&type=template&id=10682d14&", function () {
      api.rerender('10682d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/application-dictionary/components/TreeView/single-item.vue"
export default component.exports